import React from 'react';
import { Title, Icons, PageContainer } from '@/ui/components';
import { useTranslate } from '@/translations';
import { Card, Col, Row } from 'antd';
import { StorageChart } from './components/StorageChart';
import { StorageDataGrid } from './components/StorageDataGrid';
import { StorageVehicleGridDetail } from './components/StorageVehicleGrid';

export const Storage = () => {
  const { t } = useTranslate();

  return (
    <PageContainer>
      <Title title={t('compoundStorage')} icon={Icons.compound} />
      <Row gutter={16}>
        <Col lg={14} md={24}>
          <Card className="h-100">
            <StorageDataGrid />
          </Card>
        </Col>
        <Col lg={10} md={16}>
          <Card className="h-100">
            <StorageChart />
          </Card>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col lg={24}>
          <Card className="h-100">
            <StorageVehicleGridDetail />
          </Card>
        </Col>
      </Row>
    </PageContainer>
  );
};
